import React, { useState } from 'react';
import { Check, ChevronDown, ChevronUp, Square, CheckSquare, Package, Shield } from 'lucide-react';
export function Testimonials() {
  const [showBonuses, setShowBonuses] = useState(false);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 6.39;
  const bumpPrice = 9.0;
  const totalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const valorTotal = 144 + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  return <section className="py-8 px-4 md:px-6 bg-white" data-id="element-186">
      <div className="max-w-xl mx-auto" data-id="element-187">
        {/* SINGLE LARGE FLOATING CARD - White background with intense pink border */}
        <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.10)] border-2 border-[#FF4081] overflow-hidden" data-id="element-188">
          {/* INTEGRATED HEADER BAR - Pink background spanning full width */}
          <div className="bg-[#FFD1DC] px-6 md:px-8 py-3" data-id="element-189">
            <h2 className="text-xl md:text-2xl font-bold text-[#222222] uppercase tracking-wide text-center" data-id="element-190">
              OFERTA ESPECIAL DE LANZAMIENTO
            </h2>
          </div>

          {/* CONTENT AREA - Compacted padding */}
          <div className="p-4 md:p-5" data-id="element-191">
            {/* HEADER CONTINUATION - Subtitle and subtext */}
            <div className="text-center mb-4" data-id="element-192">
              <h3 className="text-lg font-semibold text-[#222222] mb-1" data-id="element-193">
                Mujer Digital 3.0
              </h3>
              <p className="text-[#555555] text-sm md:text-base leading-snug" data-id="element-194">
                Tu primer producto digital puede ser más simple de lo que
                imaginas.
              </p>
            </div>

            {/* CHECKLIST - Compacted */}
            <ul className="space-y-2 mb-4" data-id="element-195">
              {['Un método que te dice qué crear', 'Cómo estructurarlo para que se vea profesional', 'Cómo terminarlo rápido sin quemarte', 'Cómo venderlo sin sentirte incómoda'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-196">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#4CAF50]/10 flex items-center justify-center mt-0.5" data-id="element-197">
                    <Check className="w-3.5 h-3.5 text-[#4CAF50]" strokeWidth={3} data-id="element-198" />
                  </div>
                  <span className="text-[#444444] text-sm font-medium" data-id="element-199">
                    {item}
                  </span>
                </li>)}
            </ul>

            {/* BONUSES CARD - Compacted */}
            <div className="bg-[#FFF7E6] rounded-xl p-3 border border-[#FFE0B2] shadow-sm mb-4" data-id="element-200">
              <h4 className="font-bold text-[#B45309] mb-2 text-center text-sm" data-id="element-201">
                + 3 Bonos GRATIS (Valor $47.00)
              </h4>

              <ul className="space-y-1 mb-2" data-id="element-202">
                {['1. 30 Ideas listas para vender', '2. Oferta Express (15 Min)', '3. Entrega Pro (Celular)'].map((item, i) => <li key={i} className="text-xs text-[#78350F] font-medium pl-2 border-l-2 border-[#F59E0B]" data-id="element-203">
                    {item}
                  </li>)}
              </ul>

              <button onClick={() => setShowBonuses(!showBonuses)} className="w-full flex items-center justify-center gap-1 text-xs font-bold text-[#B45309] hover:text-[#92400E] transition-colors py-1" data-id="element-204">
                {showBonuses ? <>
                    Ver menos <ChevronUp className="w-3 h-3" data-id="element-205" />
                  </> : <>
                    Ver más <ChevronDown className="w-3 h-3" data-id="element-206" />
                  </>}
              </button>

              {showBonuses && <div className="mt-2 space-y-1.5 animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-207">
                  {['✅ Ideas de producto listas para copiar y lanzar', '✅ Sesión de claridad en 15 minutos', '✅ Método de entrega y testimonios listos para enviar desde tu celular'].map((item, i) => <div key={i} className="bg-[#FFF0F3] rounded-lg p-2 text-xs text-[#78350F] shadow-sm" data-id="element-208">
                      {item}
                    </div>)}
                </div>}
            </div>

            {/* PRICING BLOCK */}
            <div className="text-center border-t border-[#FFD1DC] pt-5 mb-5" data-id="element-209">
              {/* Price row with discount pill */}
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-210">
                <span className="text-gray-400 line-through text-lg font-medium" data-id="element-211">
                  $97.00
                </span>
                <span className="bg-[#28A745] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-212">
                  93% OFF
                </span>
              </div>
              {/* Larger final price for visual hierarchy */}
              <div className="mb-1" data-id="element-213">
                <span className="text-[#D6006E] text-4xl md:text-5xl font-bold" data-id="element-214">
                  ${totalPrice.toFixed(2)} USD
                </span>
              </div>
              <p className="text-[#888888] text-xs italic mb-5" data-id="element-215">
                Pago único · Acceso inmediato
              </p>

              <button className="w-full bg-[#28A745] hover:bg-[#218838] text-white font-bold py-4 rounded-full text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5" data-id="element-216">
                Completar Compra – ${totalPrice.toFixed(2)}
              </button>
            </div>

            {/* ORDER BUMPS - Compacted */}
            <div className="space-y-3 mb-4" data-id="element-217">
              {/* Bump 1 - With integrated header bar */}
              <div onClick={() => setBump1(!bump1)} className={`rounded-xl border-2 transition-all cursor-pointer shadow-sm overflow-hidden border-[#FF4081] hover:border-[#FF4DA6]`} data-id="element-218">
                {/* Integrated header bar */}
                <div className="bg-[#FFD1DC] px-3 py-1.5" data-id="element-219">
                  <p className="text-xs font-bold text-[#222222] text-center" data-id="element-220">
                    ★ ALTAMENTE RECOMENDADO ★
                  </p>
                </div>
                {/* Content area - Compacted */}
                <div className={`p-3 ${bump1 ? 'bg-[#FFE0E7]' : 'bg-[#FFF0F3]'}`} data-id="element-221">
                  <div className="flex items-start gap-2" data-id="element-222">
                    <div className="mt-0.5 text-[#FF4DA6]" data-id="element-223">
                      {bump1 ? <CheckSquare className="w-4 h-4" data-id="element-224" /> : <Square className="w-4 h-4" data-id="element-225" />}
                    </div>
                    <div className="flex-1" data-id="element-226">
                      <div className="flex justify-between items-start mb-0.5" data-id="element-227">
                        <h4 className="font-bold text-[#222222] text-sm" data-id="element-228">
                          Publica Hoy (Sin Pensar Qué Decir)
                        </h4>
                        <span className="font-bold text-[#CC0055] text-sm ml-2" data-id="element-229">
                          +$9.00
                        </span>
                      </div>
                      <p className="text-[#555555] text-xs leading-snug" data-id="element-230">
                        Agrega el Kit Copy+Paste y recibe textos listos para
                        Historias de IG + Estados de WhatsApp, con tono limpio y
                        seguro. Copia y pega, y publica para que te escriban.{' '}
                        <span className="italic" data-id="element-231">
                          "Y empieza las conversaciones sin pensar"
                        </span>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bump 2 - With integrated header bar */}
              <div onClick={() => setBump2(!bump2)} className={`rounded-xl border-2 transition-all cursor-pointer shadow-sm overflow-hidden border-[#FF4081] hover:border-[#FF4DA6]`} data-id="element-232">
                {/* Integrated header bar */}
                <div className="bg-[#FFD1DC] px-3 py-1.5" data-id="element-233">
                  <p className="text-xs font-bold text-[#222222] text-center" data-id="element-234">
                    ★ ALTAMENTE RECOMENDADO ★
                  </p>
                </div>
                {/* Content area - Compacted */}
                <div className={`p-3 ${bump2 ? 'bg-[#FFE0E7]' : 'bg-[#FFF0F3]'}`} data-id="element-235">
                  <div className="flex items-start gap-2" data-id="element-236">
                    <div className="mt-0.5 text-[#FF4DA6]" data-id="element-237">
                      {bump2 ? <CheckSquare className="w-4 h-4" data-id="element-238" /> : <Square className="w-4 h-4" data-id="element-239" />}
                    </div>
                    <div className="flex-1" data-id="element-240">
                      <div className="flex justify-between items-start mb-0.5" data-id="element-241">
                        <h4 className="font-bold text-[#222222] text-sm" data-id="element-242">
                          Cobra y Entrega Como Marca (5 Min)
                        </h4>
                        <span className="font-bold text-[#CC0055] text-sm ml-2" data-id="element-243">
                          +$9.00
                        </span>
                      </div>
                      <p className="text-[#555555] text-xs leading-snug" data-id="element-244">
                        Agrega Cobro + Entrega y recibe mensajes listos para
                        cobrar, entregar y dar seguimiento en segundos. Incluye
                        checklist para tu primera venta seria, profesional,
                        ordenada y premium desde el celular.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* DELIVERY MESSAGE + GUARANTEE - Compacted */}
            <div className="bg-[#FFF8F9] rounded-lg p-2.5 mb-3 text-center border border-[#FFD1DC] shadow-sm" data-id="element-245">
              <div className="flex items-center justify-center gap-2 text-[#555555] text-xs mb-1" data-id="element-246">
                <Package className="w-3.5 h-3.5 text-[#CC0055]" data-id="element-247" />
                <span data-id="element-248">
                  Descarga inmediata. Empieza hoy. Solo necesitas tu celular.
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 text-[#777777] text-xs" data-id="element-249">
                <Shield className="w-3.5 h-3.5 text-[#4CAF50]" data-id="element-250" />
                <span data-id="element-251">Garantía de satisfacción de 30 días</span>
              </div>
            </div>

            {/* CHECKOUT SUMMARY - Compacted */}
            <div className="bg-[#FAFAFA] rounded-xl p-3 border border-[#FFD1DC] shadow-sm mb-4" data-id="element-252">
              <div className="space-y-1 mb-2 text-sm" data-id="element-253">
                <div className="flex justify-between text-gray-500" data-id="element-254">
                  <span data-id="element-255">Mujer Digital 3.0</span>
                  <span className="line-through" data-id="element-256">$97.00</span>
                </div>
                <div className="flex justify-between text-gray-500" data-id="element-257">
                  <span data-id="element-258">3 Bonos de Lujo</span>
                  <span className="line-through" data-id="element-259">$47.00</span>
                </div>

                {bump1 && <div className="flex justify-between text-[#CC0055] animate-in fade-in slide-in-from-left-2" data-id="element-260">
                    <span data-id="element-261">+ Publica Hoy</span>
                    <span data-id="element-262">$9.00</span>
                  </div>}

                {bump2 && <div className="flex justify-between text-[#CC0055] animate-in fade-in slide-in-from-left-2" data-id="element-263">
                    <span data-id="element-264">+ Cobra y Entrega</span>
                    <span data-id="element-265">$9.00</span>
                  </div>}

                <div className="flex justify-between text-gray-500 font-medium pt-1 border-t border-gray-200" data-id="element-266">
                  <span data-id="element-267">Valor Total</span>
                  <span className="line-through" data-id="element-268">${valorTotal.toFixed(2)}</span>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-2 flex justify-between items-center" data-id="element-269">
                <span className="font-bold text-gray-900 text-sm" data-id="element-270">
                  Hoy pagas solo:
                </span>
                <span className="font-bold text-xl text-[#D6006E]" data-id="element-271">
                  ${totalPrice.toFixed(2)}
                </span>
              </div>
            </div>

            {/* SECOND CTA BUTTON */}
            <button className="w-full bg-[#28A745] hover:bg-[#218838] text-white font-bold py-4 rounded-full text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5" data-id="element-272">
              Completar Compra – ${totalPrice.toFixed(2)}
            </button>
          </div>
        </div>
      </div>
    </section>;
}